import { Divider, Popconfirm, Button } from 'antd';
import {
  ContainerOutlined,
  EditOutlined,
  WarningOutlined,
  RollbackOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';

/**
 * Returns application_date and end_date column configs for settings tables.
 * Shared by general-condition and subscription-price columns.
 * @function
 * @param {function} t - useTranslation t.
 * @param {string} formBaseKey - Base key for labels, e.g. 'general-conditions.form' or 'subscription-prices.form'.
 * @returns {Array} - Two column configs.
 */
export const createDateColumns = (t, formBaseKey) => [
  {
    title: t(`${formBaseKey}.application_date`),
    key: 'application_date',
    dataIndex: 'application_date',
    render: (date) => (date ? dayjs(date).format('DD/MM/YYYY') : ''),
    sorter: true
  },
  {
    title: t(`${formBaseKey}.end_date`),
    key: 'end_date',
    dataIndex: 'end_date',
    render: (date) => (date ? dayjs(date).format('DD/MM/YYYY') : ''),
    sorter: true
  }
];

/**
 * Returns the actions column (edit + archive/unarchive) for settings tables.
 * Shared by general-condition and subscription-price columns.
 * @function
 * @param {Object} options - The options object.
 * @param {function} options.setPurpose - Set purpose to 'edit'.
 * @param {function} options.setRecordToEdit - Set the record being edited.
 * @param {function} options.setVisible - Open drawer.
 * @param {function} options.onArchive - ({ dispatchAPI, message, record }) => archiveX(...).
 * @param {function} options.t - useTranslation t.
 * @param {function} options.dispatchAPI - API dispatch.
 * @param {function} options.message - Error message handler.
 * @returns {Object} - Actions column config.
 */
export const createArchiveActionsColumn = ({
  setPurpose,
  setRecordToEdit,
  setVisible,
  onArchive,
  t,
  dispatchAPI,
  message
}) => ({
  key: 'actions',
  align: 'right',
  fixed: 'right',
  width: 100,
  render: (record) => (
    <>
      <Divider type="vertical" />
      <Button
        type="link"
        onClick={() => {
          setPurpose('edit');
          setRecordToEdit(record);
          setVisible(true);
        }}
      >
        <EditOutlined style={{ fontSize: 18 }} />
      </Button>
      <>
        <Divider type="vertical" />
        {!record.is_archived ? (
          <Popconfirm
            title={t('datatable.column.action.archive.title')}
            okText={t('datatable.column.action.archive.ok')}
            okButtonProps={{ type: 'danger' }}
            cancelText={t('datatable.column.action.archive.cancel')}
            onConfirm={() => onArchive({ dispatchAPI, message, record })}
            icon={<WarningOutlined />}
          >
            <ContainerOutlined
              style={{ color: '#b51010', fontSize: 18 }}
              type="delete"
            />
          </Popconfirm>
        ) : (
          <Popconfirm
            title={t('datatable.column.action.unarchived.title')}
            okText={t('datatable.column.action.unarchived.ok')}
            okButtonProps={{ type: 'danger' }}
            cancelText={t('datatable.column.action.unarchived.cancel')}
            icon={<WarningOutlined />}
          >
            <RollbackOutlined style={{ color: '#b51010', fontSize: 18 }} />
          </Popconfirm>
        )}
      </>
    </>
  )
});
